import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../Typography';

const Subtext = ({
  altHeadline,
}) => {
  const headline = `Choose your favorite ${altHeadline} cakes, cupcakes, or other desserts to order online today.`;

  if (!altHeadline) return undefined;

  return (
    <div className="subtext">
      <Typography htmlTagOverride="p" variant="body">
        {headline}
      </Typography>
    </div>
  );
};

Subtext.propTypes = {
  altHeadline: PropTypes.string.isRequired,
};

export default Subtext;
